import type { SxProps, Theme } from "@mui/material/styles";

/**
 * Constraint applied to every bottom `SwipeableDrawer`'s `Paper` slot
 * so that on desktop (md+) the sheet matches the centered narrow
 * content column (maxWidth 680) rather than stretching the full page
 * width. The drawer still slides up from the bottom edge — what
 * changes is the horizontal extent.
 *
 * Why this lives in /theme: every drawer in the app (BotDetail,
 * PositionDetail, Orders, ItemAction, BuyingPower) needs identical
 * behaviour. Without a shared rule each drawer would either drift
 * on its own constants or someone would forget the cap entirely
 * when adding the next sheet.
 *
 * Mobile is untouched — the viewport and the content column converge
 * at narrow widths, so the cap has no visible effect there. Sergey
 * 2026-05-13 (desktop V2 rollout).
 */
export const desktopBottomDrawerPaperSx: SxProps<Theme> = {
  // Cap width on desktop. Below `md` (900px) we don't constrain so the
  // sheet remains edge-to-edge on phones and small tablets.
  maxWidth: { md: 680 },
  // `left: 0; right: 0; margin: 0 auto` centers a fixed-positioned
  // element with a max width. `right: 0` is required because
  // SwipeableDrawer's default Paper has `right: 0` already implicitly —
  // we restate it for clarity and to avoid relying on cascade order.
  mx: { md: "auto" },
  left: { md: 0 },
  right: { md: 0 },
};
